import { render, staticRenderFns } from "./discount2.vue?vue&type=template&id=ba809b7e&scoped=true&"
import script from "./discount2.vue?vue&type=script&lang=js&"
export * from "./discount2.vue?vue&type=script&lang=js&"
import style0 from "./discount2.vue?vue&type=style&index=0&id=ba809b7e&prod&lang=scss&"
import style1 from "./discount2.vue?vue&type=style&index=1&id=ba809b7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba809b7e",
  null
  
)

export default component.exports